export const COLORS = {
  '#FF5A4F': '#FF7E75',
  '#3787EB': '#6FA9F1',
  '#32C997': '#32C997',
  '#FFA826': '#FFC875',
  '#6457FA': '#A99EFF',
  '#FF6E41': '#FF6E41',
  '#ABBED1': '#A6A6A6',
  '#18BACE': '#19C1D7',
  '#EA54D3': '#EE72DB',
}

export const SUBTASK_BADGE = {
  name: 'Подзадача',
  bgColor: '#E4F9FC',
  color: '#18BACE',
}
export const SUBBUG_BADGE = {
  name: 'Подбаг',
  bgColor: '#FDF1FC',
  color: '#EA54D3',
}
